import oktaAuth from "../../Model/oktaAuthSingleton";
import { serverUrl } from "../../Model/serverConfig";

export const updateLeanCanvasRecord = async (recordId: string, updatedFields: { [key: string]: any }) => {
    const url = `${serverUrl}/lean-canvas/${recordId}`;

    try {
        // Get the current ID token from Okta
        const accessToken = await oktaAuth.getIdToken();

        // If the ID token is unavailable, redirect the user to sign in
        if (!accessToken) {
            oktaAuth.signInWithRedirect();
            return null; // or handle this case as needed
        }

        const response = await fetch(url, {
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accessToken}`,
            },
            body: JSON.stringify(updatedFields),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error updating record on server:", error);
        throw error;
    }
};
